import type { League } from '../league/league';
import type { Division } from './types';

// NHL team ids as used by the backend, and their three-letter abbreviations.
export const TEAM_ABBREV_BY_ID: Readonly<Record<number, string>> = {
    1: 'NJD', 2: 'NYI', 3: 'NYR', 4: 'PHI', 5: 'PIT', 6: 'BOS', 7: 'BUF', 8: 'MTL', 9: 'OTT', 10: 'TOR',
    12: 'CAR', 13: 'FLA', 14: 'TBL', 15: 'WSH', 16: 'CHI', 17: 'DET', 18: 'NSH', 19: 'STL', 20: 'CGY',
    21: 'COL', 22: 'EDM', 23: 'VAN', 24: 'ANA', 25: 'DAL', 26: 'LAK', 28: 'SJS', 29: 'CBJ', 30: 'MIN',
    52: 'WPG', 54: 'VGK', 55: 'SEA', 59: 'UTA',
};

// All team abbreviations, alphabetically.
export const TEAM_ABBREVS: readonly string[] = Object.values(TEAM_ABBREV_BY_ID).sort();

export const abbrevOfTeam = (teamId: number): string | undefined => TEAM_ABBREV_BY_ID[teamId];

// A team's abbreviation by its id, in the league's own ids.
export type TeamAbbrev = (teamId: number) => string | undefined;

// The NHL's teams are fixed; the AHL's come from its standings (AHL team ids
// are unrelated to the NHL's).
export function teamAbbrevLookup(league: League, standings: readonly Division[]): TeamAbbrev {
    if (league === 'NHL') {
        return abbrevOfTeam;
    }
    const byId = new Map(standings.flatMap(division => division.teams.map(team => [team.id, team.abbrev] as const)));
    return teamId => byId.get(teamId);
}

// The league's team abbreviations, alphabetically.
export function leagueTeamAbbrevs(league: League, standings: readonly Division[]): readonly string[] {
    return league === 'NHL'
        ? TEAM_ABBREVS
        : standings.flatMap(division => division.teams.map(team => team.abbrev)).sort();
}
